function AllUsers() {
    return (
      <>
        <div className="font-bold text-xl text-blue-800 mb-16">All Users</div>
      </>
    );
  }
  
  export default AllUsers;